module.exports = __webpack_public_path__ + "static/media/Inter-SemiBold.9b968ceb.woff";